import { createTheme } from '@mui/material/styles';
import overrides from './overrides';
import BRAND_PALETTE from './palette';
import './theme.css';

const defaultTheme = createTheme();

const theme = createTheme({
	palette: BRAND_PALETTE,
	breakpoints: {
		values: {
			...defaultTheme.breakpoints.values,
			xl: 1300,
		},
	},
	typography: {
		fontFamily: BRAND_PALETTE.fontFamily.main,
		useNextVariants: true,
		htmlFontSize: 16,
		h1: {
			fontWeight: BRAND_PALETTE.h1.fontWeight,
			fontSize: BRAND_PALETTE.h1.fontSize,
		},
		h2: {
			fontWeight: BRAND_PALETTE.h2.fontWeight,
			fontSize: BRAND_PALETTE.h2.fontSize,
		},
		h3: {
			fontWeight: BRAND_PALETTE.h3.fontWeight,
			fontSize: BRAND_PALETTE.h3.fontSize,
		},
		h4: {
			fontWeight: BRAND_PALETTE.h4.fontWeight,
			fontSize: BRAND_PALETTE.h4.fontSize,
		},
		h5: {
			fontWeight: BRAND_PALETTE.h5.fontWeight,
			fontSize: BRAND_PALETTE.h5.fontSize,
		},
		h6: {
			fontWeight: BRAND_PALETTE.h6.fontWeight,
			fontSize: BRAND_PALETTE.h6.fontSize,
		},
		heading: {
			color: BRAND_PALETTE.heading.color,
			marginTop: BRAND_PALETTE.heading.margin.top,
			marginBottom: BRAND_PALETTE.heading.margin.bottom,
			fontFamily: BRAND_PALETTE.heading.font.family,
			fontWeight: BRAND_PALETTE.heading.font.weight,
			lineHeight: BRAND_PALETTE.heading.lineHeight,
		},
		heading1: {
			fontWeight: BRAND_PALETTE.font.weightRegular,
			fontSize: BRAND_PALETTE.font.size10,
			lineHeight: BRAND_PALETTE.lineHeight.Md,
			letterSpacing: BRAND_PALETTE.letterSpacing.tight,
		},
		heading2: {
			fontWeight: BRAND_PALETTE.font.weightRegular,
			fontSize: BRAND_PALETTE.font.size9,
			lineHeight: BRAND_PALETTE.lineHeight.Md,
			letterSpacing: BRAND_PALETTE.letterSpacing.tight,
			textTransform: BRAND_PALETTE.textTransform.uppercase,
		},
		heading3: {
			fontWeight: BRAND_PALETTE.font.weightRegular,
			fontSize: BRAND_PALETTE.font.size8,
			lineHeight: BRAND_PALETTE.lineHeight.Md,
			letterSpacing: BRAND_PALETTE.letterSpacing.tight,
			textTransform: BRAND_PALETTE.textTransform.uppercase,
		},
		heading4: {
			fontWeight: BRAND_PALETTE.font.weightRegular,
			fontSize: BRAND_PALETTE.font.size6,
			lineHeight: BRAND_PALETTE.lineHeight.Md,
			letterSpacing: BRAND_PALETTE.letterSpacing.tight,
		},
		heading5: {
			fontWeight: BRAND_PALETTE.font.weightBold,
			fontSize: BRAND_PALETTE.font.size3,
			lineHeight: BRAND_PALETTE.lineHeight.Md,
			letterSpacing: BRAND_PALETTE.letterSpacing.tight,
			textTransform: BRAND_PALETTE.textTransform.uppercase,
		},
		heading6: {
			fontWeight: BRAND_PALETTE.font.weightBold,
			fontSize: BRAND_PALETTE.font.size4,
			lineHeight: BRAND_PALETTE.lineHeight.Md,
			letterSpacing: BRAND_PALETTE.letterSpacing.tight,
		},
		heading7: {
			fontWeight: BRAND_PALETTE.font.weightRegular,
			fontSize: BRAND_PALETTE.font.size5,
			lineHeight: BRAND_PALETTE.lineHeight.Md,
			letterSpacing: BRAND_PALETTE.letterSpacing.tight,
		},
		heading8: {
			fontWeight: BRAND_PALETTE.font.weightBold,
			fontSize: BRAND_PALETTE.textSize.Sm,
			lineHeight: BRAND_PALETTE.lineHeight.Md,
			letterSpacing: BRAND_PALETTE.letterSpacing.tight,
		},
		heading9: {
			fontWeight: BRAND_PALETTE.font.weightBold,
			fontSize: BRAND_PALETTE.textSize.Lg,
			lineHeight: BRAND_PALETTE.lineHeight.Md,
			letterSpacing: BRAND_PALETTE.letterSpacing.tight,
		},
		body: {
			fontWeight: BRAND_PALETTE.font.weightRegular,
			fontSize: BRAND_PALETTE.font.size2,
			lineHeight: BRAND_PALETTE.lineHeight.Md,
			letterSpacing: BRAND_PALETTE.letterSpacing.tight,
		},
		caption: {
			fontWeight: BRAND_PALETTE.font.weightRegular,
			fontSize: BRAND_PALETTE.textSize.sizeXs,
			lineHeight: BRAND_PALETTE.lineHeight.Md,
			letterSpacing: BRAND_PALETTE.letterSpacing.tight,
		},
		caption1: {
			fontWeight: BRAND_PALETTE.font.weightRegular,
			fontSize: BRAND_PALETTE.textSize.Sm,
			lineHeight: BRAND_PALETTE.lineHeight.Sm,
			letterSpacing: BRAND_PALETTE.letterSpacing.tight,
		},

		dot: {
			fontWeight: '400',
			fontSize: '1.125rem',
			letterSpacing: '0.021875rem',
		},

		header2: {
			fontWeight: '400',
			fontSize: '1.25rem',
			letterSpacing: '0.021875rem',
		},
		subtitle1: {
			fontWeight: '600',
			fontSize: '1.0625rem',
			lineHeight: 1.5,
			letterSpacing: '0.009375rem',
		},
		subtitle2: {
			fontWeight: '600',
			fontSize: '0.9375rem',
			lineHeight: 1.5,
			letterSpacing: '0.1px',
		},
		subtitle3: {
			fontWeight: '400',
			fontSize: '1rem',
			lineHeight: 1.5,
			letterSpacing: '0.009375rem',
		},
		body2: {
			fontWeight: 'normal',
			fontSize: '0.9375rem',
			lineHeight: 1.5,
			letterSpacing: '0.015625rem',
		},
		caption2: {
			fontWeight: '500',
			fontSize: '1.5rem',
			lineHeight: 1.5,
			letterSpacing: '0.009375rem',
		},
		iconMenu: {
			fontWeight: '400',
			fontSize: '0.75rem',
			lineHeight: 1.5,
			letterSpacing: '0.009375rem',
		},
		overline: {
			fontWeight: '700',
			fontSize: '0.875rem',
			lineHeight: 1.5,
			letterSpacing: '1.25px',
		},
		tableHeader: {
			fontWeight: '600',
			fontSize: '0.875rem',
			lineHeight: 1.5,
			letterSpacing: '0.4px',
		},
		tableCell: {
			fontWeight: 'normal',
			fontSize: '0.875rem',
			lineHeight: 1.5,
			letterSpacing: '0.4px',
		},
		downloadHeader: {
			fontWeight: '600',
			fontSize: '1rem',
			lineHeight: 1.25,
		},
		downloadSubHeader: {
			fontWeight: '700',
			fontSize: '0.75rem',
			lineHeight: 1,
		},
	},
	...overrides,
});

export default theme;
